import {
  AuthClientInstance,
  UserCapabilities,
  UserContracts,
  UserProfile,
  UserTokenInfo,
  UserRoles,
  UserPermissions,
} from "./types";

/**
 * Endpoint to get parsed user token (profile)
 * @param {AuthClientInstance} authClient
 */
export const getUserProfile = async (authClient: AuthClientInstance): Promise<UserProfile> => {
  const [info, capabilities, contracts, roles, permissions] = await Promise.all([
    getUserInfo(authClient),
    getUserCapabilities(authClient),
    getUserContracts(authClient),
    getUserRoles(authClient),
    getUserPermissions(authClient),
  ]);

  return { ...info, capabilities, contracts, roles, permissions };
};

export const getUserInfo = async (authClient: AuthClientInstance): Promise<UserTokenInfo> => {
  const response = await authClient.request<UserTokenInfo>({
    method: "GET",
    url: "/v1/user/info",
  });

  return response.data;
};

export const getUserCapabilities = async (authClient: AuthClientInstance): Promise<UserCapabilities> => {
  const response = await authClient.request<UserCapabilities>({
    method: "GET",
    url: "/v1/me/capabilities",
  });

  return response.data;
};

export const getUserContracts = async (authClient: AuthClientInstance): Promise<UserContracts> => {
  const response = await authClient.request<UserContracts>({
    method: "GET",
    url: "/v1/me/contracts",
  });

  return response.data;
};

export const getUserRoles = async (authClient: AuthClientInstance): Promise<UserRoles> => {
  const response = await authClient.request<UserRoles>({
    method: "GET",
    url: "/v1/me/roles",
  });

  return response.data;
};

export const getUserPermissions = async (authClient: AuthClientInstance): Promise<UserPermissions> => {
  const response = await authClient.request<UserPermissions>({
    method: "GET",
    url: "/v1/me/permissions",
  });

  return response.data;
};

/**
 * Specific endpoint to check auth state without any payload
 * @param {AuthClientInstance} authClient
 */
export const checkAuth = (authClient: AuthClientInstance): Promise<Record<string, unknown>> =>
  authClient
    .request<Record<string, unknown>>({
      method: "GET",
      url: "/v1/user/loggedin",
    })
    .then(({ data }) => data);
